import { FC } from "react";
import { eventsServiceFactory } from "../../../services/EventServiceImpl";
import { useTranslation } from "react-i18next";
import { IEvents, EventsFiltersValues } from "../../../domain/models/Events";
import { EventsFiltersFields, eventsFiltersSchemaFactory } from "../../../validation-schemas/EventsSchemas";
import { GenericEntityPage } from "../../shared/GenericEntityPage";
import EventsCard from "./EventsCard";
import { EVENTS_CLIENT_URL } from "../../../Config";
import EventsEditor from "./EventsEditor";

const eventsService = eventsServiceFactory();
const EventsPage: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericEntityPage<IEvents, EventsFiltersValues>
            filtersFieldsMeta={EventsFiltersFields}
            filtersSchema={eventsFiltersSchemaFactory(t)}
            service={eventsService}
            renderItem={(item, onEdit, onDelete) => (
                <EventsCard
                    item={item}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onClick={() => window.open(`${EVENTS_CLIENT_URL}/${item.id}`, "_blank")}
                />
            )}
            renderEditor={({ entity, onClose, onSave, translateFields }) => (
                <EventsEditor entity={entity} onClose={onClose} onSave={onSave} translateFields={translateFields} />
            )}
        />
    );
};

export default EventsPage;
